import axios from "axios";
import { secretKey } from "../../../util/config";
import { SetDevKey, setToken } from "../../../util/setAuth";
import * as ActionType from "./admin.type";
import jwt_decode from "jwt-decode";

const initialState = {
  admin: {},
  isAuth: false,
  loginType: sessionStorage.getItem("loginType") || "admin",
  permissions: JSON.parse(sessionStorage.getItem("permissions")) || [],
};



export const adminReducer = (state = initialState, action) => {
  const loginType = sessionStorage.getItem("loginType") || "admin";

  let decode;
  switch (action.type) {
    case ActionType.LOGIN_ADMIN:
      if (action.payload) {
        decode = jwt_decode(action.payload);
      }
      console.log("decode", decode)
      // Set Token And Key In Axios
      axios.defaults.headers.common["Authorization"] = action?.payload;
      SetDevKey(secretKey);
      // Set Token And Key In Session
      sessionStorage.setItem("data_", JSON.stringify(decode))
      sessionStorage.setItem("token", action?.payload);
      sessionStorage.setItem("key", secretKey);
      sessionStorage.setItem("isAuth", true);
      sessionStorage.setItem("loginType", "admin");
      sessionStorage.setItem("permissions", JSON.stringify([]));

      return {
        ...state,
        admin: decode,
        isAuth: true,
        loginType: "admin",
        permissions: [],
      };

    case ActionType.LOGIN_STAFF:
      if (action.payload.token) {
        decode = jwt_decode(action.payload.token);
      }
      // Set Token And Key In Axios
      axios.defaults.headers.common["Authorization"] = action.payload.token;
      SetDevKey(secretKey);

      // Set Token And Key In Session
      sessionStorage.setItem("data_", JSON.stringify(decode))
      sessionStorage.setItem("token", action.payload.token);
      sessionStorage.setItem("key", secretKey);
      sessionStorage.setItem("isAuth", true);
      sessionStorage.setItem("loginType", "staff");
      sessionStorage.setItem("permissions", JSON.stringify(action.payload.subAdmin.permissions || []));
      return {
        ...state,
        // admin : action.payload.subAdmin,
        admin: {
          name: action.payload.subAdmin?.name,
          email: action.payload.subAdmin.email,
          role: action.payload.subAdmin.role,
          flag: action.payload.subAdmin?.flag,
        },
        isAuth: true,
        loginType: "staff",
        permissions: action.payload.subAdmin.permissions || [],
      };

    case ActionType.LOGOUT_ADMIN:
      axios.defaults.headers.common["Authorization"] = null;
      window.sessionStorage.clear();
      window.sessionStorage.clear();
      setToken(null);
      SetDevKey(null);
      return {
        ...state,
        admin: {},
        isAuth: false,
      };

    case ActionType.PROFILE_ADMIN: {
      const storedData = JSON.parse(sessionStorage.getItem("data_") || "{}");
      if (loginType === "staff") {
        return {
          ...state,
          admin: {
            name: storedData?.name,
            email: storedData?.email,
            role: storedData?.role,
            flag: storedData?.flag,
          },
        };
      }
      return {
        ...state,
        admin: {
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          role: action.payload.role,
          fcm_token: action.payload.fcm_token,
          flag: action.payload.flag,
        },
      };
    }

    case ActionType.UPDATE_IMAGE_PROFILE:
      return {
        ...state,
        admin: {
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          flag: action.payload.flag,
        },
      };
    case ActionType.UPDATE_PROFILE:

      return {
        ...state,
        admin: action.payload,
        flag: action.payload.flag,
      };
    default:
      return state;
  }
};
